
// window.HEADER_TYPE이 simple이거나 host가 shopping, hostPathName에 detail이 포함된 경우 사용하는 gnb

import React, {useEffect, useState} from 'react'
import { HashLink } from 'react-router-hash-link'
import styled from 'styled-components'
import Api from "m_header/utils/api";
import {urlParse} from "m_header/utils/util";

const Simple = (props) => {
    const hash = window.location.hash
    let title = window.HEADER_TITLE || ''

    const [isHiddenMenu, setIsHiddenMenu] = useState(false);
    const [isShowSearchIcon, setIsShowSearchIcon] = useState(false);
    const [isShoppingDetail, setIsShoppingDatail] = useState(false)
    const [isCateId, setIsCateId] = useState('')
    const [isStdpc, setIsStdpc] = useState(false)

    const route = urlParse()
    let item_id = route.item_id
    let mall_id = route.mall_id !== 'sellerlist' ? route.mall_id : undefined


    if(props.host === 'shopping' && props.hostPathName.includes('sellerlist')){
        title = '판매처'
    } else if(props.host === 'shopping' && props.hostPathName.includes('detail')){
        title = '상품정보'
    }

    /**
     * 뒤로가기 버튼이 모바일 홈으로 가는 경우
     * - https://pc.pping.kr/
     */
    const GOTO_MAIN =[`https://pc.pping.${process.env.REACT_APP_TLD}`]

    /**
     * 메뉴를 숨겨야 하는 경우
     * - https://pc.pping.kr/compare/detail/8854
     */
    const HIDDEN_MENU = [`https://pc.pping.${process.env.REACT_APP_TLD}/compare/detail`]

    /**
     * 돋보기 아이콘을 보여줘야 하는 경우
     * @type {string[]}
     */
    const SHOW_SEARCH_ICON = [
        `https://shopping.pping.${process.env.REACT_APP_TLD}/detail/`,
    ]

    const handleShowMenu = (URL,HIDDEN_MENU) => {
        const arr = HIDDEN_MENU.filter((item)=>(URL.includes(item)))
        setIsHiddenMenu(arr.length > 0)
    }

    const handleSearchIcon = (URL,SHOW_SEARCH_ICON) => {
        const arr = SHOW_SEARCH_ICON.filter((item)=>(URL.includes(item)))
        setIsShowSearchIcon(arr.length > 0)
    }

    const validShoppingDetail = (host,hostPathName) => {
        if(host === 'shopping' && hostPathName.includes('detail') && !hostPathName.includes('sellerlist')){
            setIsShoppingDatail(true)
        } else setIsShoppingDatail(false)
    }

    const fetchItem = async (item_id, mall_id) => {
        const result = await Api.getItem(item_id, mall_id)
        return result.data.result.item.cate_id
    }

    function onHistoryBack() {
        window.history.back()
    }

    useEffect(() => {
        handleShowMenu(props.URL,HIDDEN_MENU )
        handleSearchIcon(props.URL, SHOW_SEARCH_ICON)
        validShoppingDetail(props.host, props.hostPathName)
    }, [])

    useEffect(() => {
        const fetchingItem = async (item_id, mall_id) => {
            const cateId = await fetchItem(item_id, mall_id)
            setIsCateId(String(cateId))
        }
        if(isShoppingDetail){
            fetchingItem(item_id, mall_id)
        }

    }, [isShoppingDetail])


    useEffect(() => {
        if(isCateId.slice(0, 1) === '2'){
            setIsStdpc(true)
        } else setIsStdpc(false)
    }, [isCateId]);

    return (
        <div className="headerC" >
            <div className="hdWrap">
                <EstimateHeader>
                    <EstimateArrow>
                        {/*경로에 따른 뒤로가기 버튼 기능 설정*/}
                        {
                            GOTO_MAIN.includes(props.URL)
                                ? <a href={`${process.env.REACT_APP_M_URL}`}>
                                    <button type="button" className="icon-arrow_back" ></button></a>
                                : <button type="button" className="icon-arrow_back" onClick={()=>onHistoryBack()}></button>
                        }
                    </EstimateArrow>
                    <WrapHeaderTitle>
                        <strong  id="headerTitleArea">{title}</strong>
                    </WrapHeaderTitle>
                    <EstimateRight
                        style={{visibility : `${isHiddenMenu ? 'hidden' : ''}`}}
                    >
                        {isShowSearchIcon &&
                            <a href={`${process.env.REACT_APP_SEARCH_URL}`}>
                                <SearchIcon className="icon-bottom_zoomlens" />
                            </a>
                        }
                        {isStdpc
                            ? <a href={process.env.REACT_APP_CART_URL}  >
                                <Cart className="header_component_cart"/>
                            </a>
                            : <HashLink to={`${hash === '#aside' ? '#' : '#aside'}`}>
                                <AllMenu className="header_component_menu" /></HashLink>
                        }
                    </EstimateRight>
                </EstimateHeader>
            </div>
        </div>
    )
}

const EstimateHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
    height: 48px;
    border-bottom: 1px solid #D6D6D6;
`

const EstimateArrow = styled.div`
    width: 25%;
    font-size: 24px;
`
const WrapHeaderTitle = styled.div`
    width: 50%;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`

const EstimateRight = styled.div`
    width: 25%;
    font-size: 18px;
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: center;
`

const AllMenu = styled.button`
    width: 36px;
    height: 36px;
    border: 0;
    background: none;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    &:after {
        overflow: hidden;
        display: block;
        position: relative;
        font-family: 'ppingkr_v4';
        content: '\\ea2d';
        color: #333;
        font-size: 17px;
        width: 22px;
    }
`

const SearchIcon = styled.i`
    margin-right: 8px;
    font-size: 21px;
`

const Cart = styled.button`
    width: 36px;
    height: 36px;
    border: 0;
    background: none;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    &:after {
        display: block;
        position: relative;
        font-family: 'ppingkr_v4';
        content: '\\ea2c';
        color: #333;
        font-size: 22px;
        width: 22px;
    }
`

export default Simple



// WEBPACK FOOTER //
// ./src/m_header/pages/simple/index.js